import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Link, LinkDetail } from '../types/link';
import { getRequest } from './api';
import { linkUrl, linksUrl } from './urls/linkUrls';

export const getLinks = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<Link>; error?: ApiError }> => {
  const response = await getRequest(linksUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const getLinkDetail = async (
  clientId: string,
  subClientId: string,
  linkId: string
): Promise<{ linkDetail: LinkDetail; error?: ApiError }> => {
  const response = await getRequest(linkUrl(linkId), { queryParams: { clientId, subClientId } });
  return {
    linkDetail: response?.data,
    error: response?.error,
  };
};
